import { useTabStore } from "../store/tab-store";
import styled from "styled-components";
import { CouponRulesList } from "../constant/coupon-list";
import { useTranslation } from "react-i18next";

export function CouponRules() {
  const { showRules, setShowRules } = useTabStore();
  const { t: desktopT } = useTranslation("desktop");

  if (!showRules) return null;
  return (
    <CouponRulesWrapper>
      <CouponRulesHeader>
        <span>{desktopT("desktop_rules_title")}</span>
        <CloseIcon onClick={() => setShowRules(false)} />
      </CouponRulesHeader>
      <CouponRulesContent>
        {CouponRulesList.map(
          (item: { rules: string[]; title: string; key: number }) => {
            return (
              <CouponRulesSection key={item.title}>
                <CouponRulesTitle>{`${desktopT(item.title)}`}</CouponRulesTitle>
                {item.rules.map((p, index) => {
                  return (
                    <CouponRulesItem key={p}>{desktopT(p)}</CouponRulesItem>
                  );
                })}
              </CouponRulesSection>
            );
          }
        )}
      </CouponRulesContent>
    </CouponRulesWrapper>
  );
}

const CouponRulesWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #343538;
  background: #292b2f;
  min-width: 386px;
  width: 386px;
`;

const CouponRulesHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  padding-left: 12px;
  border-bottom: 1px solid #404246;
`;

const CloseIcon = styled.span`
  position: relative;
  width: 16px;
  height: 16px;
  right: 14px;
  transform: rotate(45deg);
  cursor: pointer;
  &::before {
    height: 100%;
    content: "";
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    border-left: 1px solid #778086;
  }
  &::after {
    width: 100%;
    content: "";
    position: absolute;
    bottom: 50%;
    transform: translate(0, 50%);
    border-bottom: 1px solid #778086;
  }
`;

const CouponRulesContent = styled.div`
  padding: 16px 12px;
`;

const CouponRulesSection = styled.div`
  margin-bottom: 24px;
`;

const CouponRulesTitle = styled.div`
  margin-bottom: 6px;
  font-weight: 600;
`;

const CouponRulesItem = styled.div`
  color: #b3bac0;
  line-height: 20px;
`;
